<template>
  <div class="layout">
    <div class="menu">
      <Menu topIndex="4"></Menu>
    </div>
    <div class="leftSide">
      <LeftSideBar current="dbWork" leftIndex="bigEvent"></LeftSideBar>
    </div>

    <div id="deptContentBox" class="base-content">
      <!-- 上方按钮 -->
      <div>
        <el-button
          type="text"
          size="small"
          icon="el-icon-plus"
          @click="firstCreate()"
          >新增
        </el-button>
        <el-button type="text" size="small" icon="el-icon-edit">
          编辑</el-button
        >
        <el-button type="text" size="small" icon="el-icon-close">
          删除</el-button
        >
        <el-button type="text" size="small" icon="el-icon-download">
          批量导入</el-button
        >
        <el-button type="text" size="small" icon="el-icon-upload2">
          导出EXCEL</el-button
        >
      </div>
      <!-- 上方按钮end -->
      <!-- 搜索 -->
      <div id="searchBox">
        <el-form label-width="60px">
          <el-form-item label="关键字">
            <el-input placeholder="请输入关键字"></el-input>
          </el-form-item>
          <el-form-item label="年表分类" label-width="80px">
            <el-input placeholder="请输入年表分类"></el-input>
          </el-form-item>
          <el-button type="primary" icon="el-icon-search">查询</el-button>
          <el-button type="primary" size="mini" icon="el-icon-delete"
            >重置</el-button
          >
        </el-form>
      </div>
      <!-- 搜索end -->
      <el-table
        :data="tableData"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        style="width: 100%"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
      >
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column
          prop="eventYear"
          show-overflow-tooltip
          label="年代"
          min-width="60"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="eventDate"
          show-overflow-tooltip
          label="日期"
          min-width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="eventText"
          show-overflow-tooltip
          label="事件"
          min-width="150"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="wordName"
          show-overflow-tooltip
          label="关联条目"
          min-width="150"
          align="center"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="是否日历展示"
          min-width="150"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.isCalendar == 1">否</span>
            <span v-if="scope.row.isCalendar == 2">是</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="eventType"
          show-overflow-tooltip
          label="年表分类"
          min-width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="remark"
          show-overflow-tooltip
          label="备注"
          min-width="80"
          align="center"
        >
        </el-table-column>
      </el-table>
      <!-- <div class="pagination-box">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        >
        </el-pagination>
      </div> -->
    </div>
    <el-dialog
      title="新增/编辑大事记"
      :visible.sync="createDialog"
      width="800px"
    >
      <el-form label-width="120px">
        <el-form-item label="年代" prop="eventYear">
          <el-input placeholder="请输入年代" style="width: 200px"></el-input
          >（格式为XXXX年）
        </el-form-item>
        <el-form-item label="日期">
          <el-input placeholder="请输入日期"></el-input>
        </el-form-item>
        <el-form-item label="年表分类">
          <el-input placeholder="请输入年表分类"></el-input>
        </el-form-item>
        <el-form-item label="事件" class="multiHeight" prop="eventText">
          <el-input
            type="textarea"
            :rows="5"
            placeholder="请输入事件内容"
          ></el-input>
        </el-form-item>
        <el-form-item label="关联条目" class="multiHeight">
          <span v-if="relateWordName"> {{ relateWordName }} </span>
          <el-button type="text" size="mini" icon="el-icon-plus"
            >选择</el-button
          >
        </el-form-item>
        <el-form-item label="是否日历展示" prop="isCalendar">
          <el-switch
            active-color="#13ce66"
            inactive-color="#ccc"
            active-text="是"
            inactive-text="否"
          ></el-switch>
        </el-form-item>
        <el-form-item label="日历展示时间" class="multiHeight">
          <el-input placeholder="请输入日历展示时间"></el-input>
          <span style="color: red">格式为XX月XX日（如：5月5日或10月15日）</span>
        </el-form-item>
        <el-form-item label="日历展示图片" class="multiHeight">
          <img
            :src="sitePrefix + logoUrl"
            v-if="logoUrl"
            alt=""
            width="100px"
          />
          <span class="upload-box">
            <span class="filename" :title="importname">{{ importname }}</span>
            <span class="select-icon-box">
              <form enctype="multipart/form-data" id="updateLogo">
                <input
                  type="file"
                  id="updateLogoFile"
                  class="upload-input"
                  @change="updateLogo"
                />
              </form>
              <i class="el-icon-folder-opened" style="font-size: 17px"></i
              >&nbsp;&nbsp;选择文件
            </span>
          </span>
        </el-form-item>
        <el-form-item label="备注">
          <el-input placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary">确 定 </el-button>
        <el-button @click="createDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Menu from "../../menu/menu.vue";
import LeftSideBar from "../../menu/leftSideBar.vue";
// import $ from "jquery";
export default {
  components: {
    Menu,
    LeftSideBar,
  },
  data() {
    return {
      current: "dept",
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄",
        },
      ],
      createDialog: false,
    };
  },
  methods: {
    // 显示新增弹框
    firstCreate() {
      this.createDialog = true;
    },
    deletePre() {},
  },
};
</script>

<style>
</style>